import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Subscription, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-modal-responsavel',
  templateUrl: './modal-responsavel.component.html',
  styleUrls: ['./modal-responsavel.component.scss']
})
export class ModalResponsavelComponent implements OnInit, OnDestroy {
  searchControl = new FormControl('');
  prazoControl = new FormControl<Date | null>(null);
  filteredOptionsUsers: any[] = [];
  selectedOption: any;
  subscriptions: Subscription[] = [];
  responsavel: any = {};

  constructor(
    private dialogRef: MatDialogRef<ModalResponsavelComponent>,
    private userService: UserService,
    private projetosService: ProjetosService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: {
      id: string;
      projectId: string;
      disciplinaId?: string;
      responsavel: any;
      prazo: string | null;
    }
  ) {
    this.responsavel = data?.responsavel;
    this.searchControl.setValue(this.responsavel && this.responsavel.nome ? this.responsavel.nome : '', { emitEvent: false });
    this.selectedOption = this.responsavel;
    if (data?.prazo) {
      this.prazoControl.setValue(moment(data.prazo, 'YYYY-MM-DD').toDate());
    }
  }
  ngOnInit(): void {
    this.getFirstUsers();
    this.setupAutocomplete();
    
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setupAutocomplete(): void {
    this.subscriptions.push(
      this.searchControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => typeof value === 'string' && value.trim().length > 0),
        map(value => this.normalizeString(value as string)),
        switchMap(value => this.fetchUsers(value))
      ).subscribe((results: any) => {
        this.filteredOptionsUsers = results.content || [];
        
      })
    );
  }

  private normalizeString(value: string): string {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  }

  private fetchUsers(term: string) {
    return this.userService.getUsers(0, 10, 'asc', 'nome', term, 'true').pipe(
      catchError(() => of([]))
    );
  }

  getFirstUsers(): void {
    this.subscriptions.push(
      this.userService.getUsers(0, 10, 'asc', 'nome', '', 'true').subscribe((results: any) => {
        this.filteredOptionsUsers = results.content || [];
      })
    );
  }

  onOptionSelected(event: any): void {
    const selectedOption = event.option.value;
    this.selectedOption = selectedOption;
    this.searchControl.setValue(selectedOption.nome, { emitEvent: false });
    this.filteredOptionsUsers = [];
  }

  onSubmit(): void {
    if (!this.selectedOption) return;

    const prazo = this.prazoControl.value
      ? moment(this.prazoControl.value).format('YYYY-MM-DD')
      : null;

    const request$ = this.data.disciplinaId
      ? this.projetosService.editarResponsavelAnaliseDisciplina(
          this.data.projectId, this.data.disciplinaId, this.data.id,
          this.selectedOption.id, prazo)
      : this.projetosService.editarResponsavelAnalise(
          this.data.projectId, this.data.id, this.selectedOption.id, prazo);

    request$.subscribe({
      next: () => {
        this.toastService.showSuccess('Análise editada com sucesso.');
        this.dialogRef.close(true);
      },
      error: (erro: any) => {
        const mensagem = erro?.error?.message || 'Erro ao editar o análise.';
        this.toastService.showError(mensagem);
      }
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}